define(['jquery', 'jquery.cookie'], function ($) {

  // nasze parametry jakie mogą występować
  var cookieParams = [
    'saleschannel',
    'agency',
    'portal',
    'wid2',
    'sellingleadid',
    'Promotion',
    'contactid',
    'wid',
    'agent',
    'membercode'
  ];

  // dodatkowe metody dla jquery - pobieranie parametrów
  $.extend({

    getUrlVars: function () {

      var vars = [],
        locationSearch = window.location.search,
        hash,
        hashes = locationSearch.slice(locationSearch.indexOf('?') + 1);

      if (hashes !== '') {

        hashes = hashes.split('&');

        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
        }

      }

      return vars;

    }/*,
     // nieużywane
     getUrlVar: function(name) {
     return $.getUrlVars()[name];
     }*/

  });

  function widCookie() {

    // pobieramy parametry z url
    var urlParams = $.getUrlVars(),
      hrefParams = [],
      $links,
      newWidCookieIncoming;

    // jeśli mamy parametry w url
    if (urlParams.length) {

      // sprawdzamy czy mamy jakieś nowe cookie widowe
      $.each(cookieParams, function (index, param) {
        if ($.inArray(param, urlParams) > -1) {
          newWidCookieIncoming = true;
          return false;
        }
      });

      if (newWidCookieIncoming) {

        // kasujemy stare cookie widowe jeśli są nowe
        $.each(cookieParams, function (index, param) {
          $.removeCookie(param, {
            path: '/'
          });
        });

        // dodajemy nowe cookie widowe
        $.each(urlParams, function (index, param) {
          if ($.inArray(param, cookieParams) > -1) {
            $.cookie(param,
              // kasowanie hasza na końcu parametru
              urlParams[param].replace(/#$/g, ''), {
                expires: 7,
                path: '/'
              });
          }
        });

      }

    }

    // przygotwujemy tablicę z parametrami widowymi...
    $.each(cookieParams, function (index, param) {
      var cookieValue = $.cookie(param);
      if (cookieValue != null) {
        hrefParams.push(param + '=' + cookieValue);
      }
    });

    // ...i dodajemy parametry do linków z klasą sprzedaz jeśli jakieś
    // parametry są
    if (hrefParams.length) {

      hrefParams = hrefParams.join('&');

      $links = $('a.sprzedaz');

      if ($links.length) {

        $links.each(function () {
          var item = $(this),
            oldHref = item.attr('href'),
            newHref;
          if (oldHref) {
            newHref = oldHref +
              (oldHref.indexOf('?') === -1 ? '?' : '&') + hrefParams;
            item.attr('href', newHref);
          }
        });

      }
    }

  }

  $(document).ready(widCookie);

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/shared/wid.js